import type { AppAction } from '@app/state'

export type NameInputFilter = string

export interface State {
  nameInputFilter?: NameInputFilter
  pageNumber: number
  recordsPerPage: number
  sortField?: string
  sortDirection?: string
  typeInputFilter?: string
}

export const initialState: State = {
  nameInputFilter: null,
  pageNumber: 1,
  recordsPerPage: 50,
  typeInputFilter: null,
}

export enum ActionType {
  SetTypeInputFilter = 'INSTRUMENT_LIST/SET_TYPE_INPUT_FILTER',
  SetNameInputFilter = 'INSTRUMENT_LIST/SET_NAME_INPUT_FILTER',
  SetPageNumber = 'INSTRUMENT_LIST/SET_PAGE_NUMBER',
  SetRecordsPerPage = 'INSTRUMENT_LIST/SET_RECORDS_PER_PAGE',
  SetSort = 'INSTRUMENT_LIST/SET_SORT',
}

export type Action =
  | { type: ActionType.SetTypeInputFilter; value?: string }
  | { type: ActionType.SetNameInputFilter; value?: string }
  | { type: ActionType.SetPageNumber; value: number }
  | { type: ActionType.SetRecordsPerPage; value: number }
  | { type: ActionType.SetSort; field?: string; direction?: string }

export const actions = {
  setTypeInputFilter(value?: string) {
    return { type: ActionType.SetTypeInputFilter, value }
  },
  setNameInputFilter(value?: NameInputFilter) {
    return { type: ActionType.SetNameInputFilter, value }
  },
  setPageNumber(value: number) {
    return { type: ActionType.SetPageNumber, value }
  },
  setRecordsPerPage(value: number) {
    return { type: ActionType.SetRecordsPerPage, value }
  },
  setSort(field?: string, direction?: string) {
    return { type: ActionType.SetSort, field, direction }
  },
}

export function reducer(state: State = initialState, action: AppAction): State {
  switch (action.type) {
    case ActionType.SetTypeInputFilter:
      return {
        ...state,
        typeInputFilter: action.value,
      }

    case ActionType.SetNameInputFilter:
      return {
        ...state,
        nameInputFilter: action.value,
      }
    case ActionType.SetPageNumber:
      return {
        ...state,
        pageNumber: action.value,
      }

    case ActionType.SetRecordsPerPage:
      return {
        ...state,
        recordsPerPage: action.value,
      }
    case ActionType.SetSort:
      return {
        ...state,
        sortField: action.field,
        sortDirection: action.direction,
      }
    default:
      return state
  }
}
